import React, { useState } from 'react';

const CONTATO = '5511956922677';

const LOGO_SVG_BRANCO = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 220 72" height="48">
  <g transform="translate(4,4)">
    <path d="M28 22 Q28 10 40 10 Q52 10 52 22" stroke="#F4A020" stroke-width="3.5" fill="none" stroke-linecap="round"/>
    <rect x="16" y="22" width="48" height="38" rx="4" fill="none" stroke="#fff" stroke-width="3.5"/>
    <line x1="16" y1="36" x2="64" y2="36" stroke="#fff" stroke-width="1.5" stroke-dasharray="4 3"/>
    <path d="M27 52 L40 38 M40 38 L40 46 M40 38 L32 38" stroke="#F4A020" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
  </g>
  <text x="82" y="38" font-family="Arial Black,sans-serif" font-size="26" font-weight="900" fill="#fff">MOGI</text>
  <text x="82" y="58" font-family="Arial Black,sans-serif" font-size="16" font-weight="900" fill="#F4A020" letter-spacing="3">OUTLET</text>
</svg>`;

function gerarHTML(products, logoBase64) {
  const produtosJSON = JSON.stringify(products);

  const logoHeader = logoBase64
    ? `<img src="${logoBase64}" alt="Mogi Outlet" height="56" style="display:block;object-fit:contain">`
    : LOGO_SVG_BRANCO;

  const logoHero = logoBase64
    ? `<img src="${logoBase64}" alt="Mogi Outlet" height="160" style="display:block;object-fit:contain;margin:0 auto 28px">`
    : `<div style="margin-bottom:28px">${LOGO_SVG_BRANCO}</div>`;

  // Primeira imagem externa disponível (URL http/https) para og:image
  // WhatsApp não aceita base64 — precisa ser URL pública
  const ogImage = products.reduce((found, p) => {
    if (found) return found;
    const imgs = p.imagens && p.imagens.length ? p.imagens : (p.imagem ? [p.imagem] : []);
    return imgs.find(img => img && img.startsWith('http')) || null;
  }, null) || '';

  const ogTitle = 'Mogi Outlet — Produtos com desconto real';
  const ogDesc  = 'Logística reversa em Mogi das Cruzes. Produtos de devoluções e sobras de estoque com preços muito abaixo do mercado!';

  return `<!DOCTYPE html>
<html lang="pt-BR">
<head>
  <meta charset="UTF-8" />
  <meta name="viewport" content="width=device-width, initial-scale=1.0" />
  <title>Mogi Outlet</title>

  <!-- Open Graph / WhatsApp preview -->
  <meta property="og:type"        content="website" />
  <meta property="og:title"       content="${ogTitle}" />
  <meta property="og:description" content="${ogDesc}" />
  <meta name="description"        content="${ogDesc}" />
  ${ogImage ? `<meta property="og:image"       content="${ogImage}" />
  <meta property="og:image:width"  content="800" />
  <meta property="og:image:height" content="600" />
  <meta name="twitter:card"        content="summary_large_image" />` : ''}

  ${logoBase64 ? `<link rel="icon" type="image/png" href="${logoBase64}">` : ''}
  <link rel="preconnect" href="https://fonts.googleapis.com" />
  <link href="https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800;900&display=swap" rel="stylesheet" />
  <style>
    :root {
      --azul: #1C3B6E;
      --azul-escuro: #142d56;
      --laranja: #F4A020;
      --laranja-escuro: #d98c18;
      --cinza-bg: #f5f6f8;
      --texto: #1a1a2e;
      --texto-suave: #64748b;
    }
    *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
    html { scroll-behavior: smooth; }
    body { font-family: 'Inter', sans-serif; background: var(--cinza-bg); color: var(--texto); }

    /* ── HEADER ─── */
    header { background: var(--azul); position: sticky; top: 0; z-index: 200; box-shadow: 0 2px 16px rgba(0,0,0,0.25); }
    .header-inner { max-width: 1200px; margin: 0 auto; padding: 0 24px; height: 68px; display: flex; align-items: center; justify-content: space-between; gap: 16px; }
    .logo-link { display: flex; align-items: center; text-decoration: none; }
    nav { display: flex; align-items: center; gap: 6px; }
    .nav-btn { background: none; border: none; cursor: pointer; color: rgba(255,255,255,0.75); font-size: 14px; font-weight: 600; padding: 8px 14px; border-radius: 8px; transition: all .2s; font-family: inherit; }
    .nav-btn:hover, .nav-btn.ativo { background: rgba(255,255,255,0.12); color: #fff; }
    .nav-wa { display: flex; align-items: center; gap: 7px; background: #25d366; color: #fff; border: none; border-radius: 8px; padding: 9px 18px; font-size: 14px; font-weight: 700; cursor: pointer; transition: background .2s; font-family: inherit; text-decoration: none; }
    .nav-wa:hover { background: #1ebc59; }
    .nav-mob-cat { display: none; background: rgba(255,255,255,0.15); border: none; color: #fff; border-radius: 8px; padding: 9px 16px; font-size: 14px; font-weight: 700; cursor: pointer; font-family: inherit; transition: background .2s; white-space: nowrap; }
    .nav-mob-cat:hover { background: rgba(255,255,255,0.28); }

    /* ── PAGES ── */
    .page { display: none; }
    .page.ativo { display: block; }

    /* ── HOME HERO ── */
    .hero { background: linear-gradient(135deg, var(--azul) 0%, var(--azul-escuro) 60%, #0d1f3c 100%); color: #fff; text-align: center; padding: 80px 24px 72px; position: relative; overflow: hidden; }
    .hero::before { content: ''; position: absolute; inset: 0; background: radial-gradient(ellipse at 70% 50%, rgba(244,160,32,0.12) 0%, transparent 65%); pointer-events: none; }
    .hero h1 { font-size: clamp(32px, 5vw, 54px); font-weight: 900; letter-spacing: -1.5px; line-height: 1.1; margin-bottom: 16px; }
    .hero h1 span { color: var(--laranja); }
    .hero p { font-size: 18px; color: rgba(255,255,255,0.75); max-width: 480px; margin: 0 auto 36px; line-height: 1.6; }
    .hero-btns { display: flex; gap: 12px; justify-content: center; flex-wrap: wrap; }
    .btn-hero-primary { background: var(--laranja); color: #fff; border: none; border-radius: 10px; padding: 17px 40px; font-size: 19px; font-weight: 800; cursor: pointer; transition: all .2s; font-family: inherit; }
    .btn-hero-primary:hover { background: var(--laranja-escuro); transform: translateY(-2px); box-shadow: 0 8px 24px rgba(244,160,32,0.4); }
    .btn-hero-ghost { background: rgba(255,255,255,0.1); color: #fff; border: 2px solid rgba(255,255,255,0.3); border-radius: 10px; padding: 13px 28px; font-size: 16px; font-weight: 600; cursor: pointer; transition: all .2s; font-family: inherit; text-decoration: none; display: inline-block; }
    .btn-hero-ghost:hover { background: rgba(255,255,255,0.18); }

    /* ── DIFERENCIAIS ── */
    .diferenciais { max-width: 1200px; margin: 64px auto; padding: 0 24px; display: grid; grid-template-columns: repeat(auto-fit, minmax(220px, 1fr)); gap: 20px; }
    .dif-card { background: #fff; border-radius: 14px; padding: 28px 24px; box-shadow: 0 2px 12px rgba(0,0,0,0.06); border-top: 4px solid var(--laranja); transition: transform .2s, box-shadow .2s; }
    .dif-card:hover { transform: translateY(-4px); box-shadow: 0 10px 28px rgba(0,0,0,0.1); }
    .dif-icon { font-size: 36px; margin-bottom: 14px; }
    .dif-card h3 { font-size: 17px; font-weight: 700; color: var(--azul); margin-bottom: 8px; }
    .dif-card p { font-size: 14px; color: var(--texto-suave); line-height: 1.6; }

    /* ── SOBRE ── */
    .sobre { background: var(--azul); color: #fff; text-align: center; padding: 72px 24px; }
    .sobre-inner { max-width: 640px; margin: 0 auto; }
    .sobre h2 { font-size: clamp(24px, 3.5vw, 36px); font-weight: 800; margin-bottom: 20px; }
    .sobre h2 span { color: var(--laranja); }
    .sobre p { font-size: 16px; color: rgba(255,255,255,0.8); line-height: 1.8; margin-bottom: 14px; }
    .sobre-cidade { display: inline-flex; align-items: center; gap: 6px; background: rgba(255,255,255,0.1); border-radius: 999px; padding: 6px 16px; font-size: 14px; font-weight: 600; margin-top: 8px; }

    /* ── CTA ── */
    .cta { max-width: 700px; margin: 64px auto; padding: 0 24px; text-align: center; }
    .cta h2 { font-size: clamp(22px, 3vw, 32px); font-weight: 800; color: var(--azul); margin-bottom: 12px; }
    .cta p { font-size: 15px; color: var(--texto-suave); margin-bottom: 28px; line-height: 1.6; }
    .btn-cta-wa { display: inline-flex; align-items: center; gap: 10px; background: #25d366; color: #fff; border: none; border-radius: 10px; padding: 16px 36px; font-size: 17px; font-weight: 700; cursor: pointer; transition: all .2s; text-decoration: none; font-family: inherit; }
    .btn-cta-wa:hover { background: #1ebc59; transform: translateY(-2px); box-shadow: 0 8px 24px rgba(37,211,102,0.35); }

    /* ── CATÁLOGO ── */
    .cat-header { background: linear-gradient(135deg, var(--azul), var(--azul-escuro)); color: #fff; padding: 40px 24px 32px; text-align: center; }
    .cat-header h2 { font-size: 28px; font-weight: 800; margin-bottom: 6px; }
    .cat-header p { color: rgba(255,255,255,0.7); font-size: 14px; }
    .busca-wrap { max-width: 1200px; margin: 24px auto 0; padding: 0 24px; }
    .busca-inner { display: flex; gap: 10px; align-items: center; }
    .busca-inner input { flex: 1; padding: 14px 18px; font-size: 15px; font-family: inherit; border: 2px solid #e2e8f0; border-radius: 10px; outline: none; background: #fff; transition: border .2s; }
    .busca-inner input:focus { border-color: var(--laranja); }
    .btn-abrir-filtros { display: none; background: var(--azul); color: #fff; border: none; border-radius: 10px; padding: 14px 18px; font-size: 14px; font-weight: 700; cursor: pointer; font-family: inherit; white-space: nowrap; transition: background .2s; flex-shrink: 0; }
    .btn-abrir-filtros:hover { background: var(--azul-escuro); }

    /* ── LAYOUT CATÁLOGO (sidebar + grade) ── */
    .catalogo-layout { max-width: 1200px; margin: 20px auto 80px; padding: 0 24px; display: flex; gap: 24px; align-items: flex-start; }
    .sidebar-backdrop { display: none; position: fixed; inset: 0; background: rgba(0,0,0,0.5); z-index: 299; }
    .sidebar-backdrop.aberto { display: block; }
    .sidebar-filtros { width: 210px; flex-shrink: 0; background: #fff; border-radius: 12px; box-shadow: 0 2px 12px rgba(0,0,0,0.08); position: sticky; top: 80px; max-height: calc(100vh - 96px); overflow-y: auto; }
    .sidebar-header { padding: 16px 18px 12px; display: flex; align-items: center; justify-content: space-between; border-bottom: 1px solid #f1f5f9; }
    .sidebar-header span { font-size: 15px; font-weight: 700; color: var(--azul); }
    .sidebar-fechar { display: none; background: #f1f5f9; border: none; border-radius: 50%; width: 28px; height: 28px; font-size: 14px; cursor: pointer; align-items: center; justify-content: center; color: #555; transition: background .2s; }
    .sidebar-fechar:hover { background: #e2e8f0; }
    .sidebar-body { padding: 8px 0 14px; }
    .sidebar-secao { padding: 10px 14px; }
    .sidebar-secao-label { display: block; font-size: 10px; font-weight: 700; color: var(--texto-suave); text-transform: uppercase; letter-spacing: 0.8px; margin-bottom: 8px; }
    .sidebar-divider { height: 1px; background: #f1f5f9; margin: 4px 14px 2px; }
    .sort-select { width: 100%; padding: 8px 10px; font-size: 13px; font-family: inherit; border: 2px solid #e2e8f0; border-radius: 8px; outline: none; cursor: pointer; background: #fff; color: var(--texto); transition: border .2s; }
    .sort-select:focus { border-color: var(--laranja); }
    .cat-item { display: block; width: 100%; text-align: left; padding: 8px 10px; border: none; background: none; font-size: 13px; font-family: inherit; color: var(--texto); border-radius: 7px; cursor: pointer; transition: background .2s, color .2s; }
    .cat-item:hover { background: #f1f5f9; }
    .cat-item.ativo { background: var(--laranja); color: #fff; font-weight: 600; }
    .cat-item.subcat { font-size: 12px; color: var(--texto-suave); }
    .cat-item.subcat.ativo { background: rgba(244,160,32,0.18); color: #b8720a; font-weight: 600; }
    .conteudo-catalogo { flex: 1; min-width: 0; }
    .grade { display: grid; grid-template-columns: repeat(auto-fill, minmax(200px, 1fr)); gap: 20px; }
    .card-vendido { opacity: 0.6; }
    .badge-vendido { position: absolute; top: 10px; left: 10px; background: rgba(0,0,0,0.72); color: #fff; border-radius: 6px; padding: 3px 10px; font-size: 11px; font-weight: 700; letter-spacing: 1px; }
    .card-estoque { font-size: 11px; color: #64748b; margin-top: 2px; }

    /* ── CARD ── */
    .card { background: #fff; border-radius: 14px; overflow: hidden; box-shadow: 0 2px 10px rgba(0,0,0,0.07); transition: transform .2s, box-shadow .2s; display: flex; flex-direction: column; }
    .card:hover { transform: translateY(-5px); box-shadow: 0 14px 32px rgba(0,0,0,0.12); }
    .card-foto { width: 100%; aspect-ratio: 1; overflow: hidden; background: #fff; position: relative; display: flex; align-items: center; justify-content: center; font-size: 52px; color: #cbd5e1; cursor: pointer; }
    .card-foto img { width: 100%; height: 100%; object-fit: contain; display: block; background: #fff; }
    .badge-off { position: absolute; top: 10px; right: 10px; background: #ef4444; color: #fff; border-radius: 6px; padding: 3px 8px; font-size: 11px; font-weight: 700; }
    .foto-count { position: absolute; bottom: 8px; left: 8px; background: rgba(0,0,0,0.55); color: #fff; border-radius: 10px; padding: 2px 8px; font-size: 11px; font-weight: 600; }
    .card-body { padding: 14px; display: flex; flex-direction: column; flex: 1; gap: 5px; }
    .card-nome { font-size: 14px; font-weight: 700; color: var(--texto); line-height: 1.3; cursor: pointer; }
    .card-nome:hover { color: var(--azul); }
    .card-dim { font-size: 12px; color: var(--texto-suave); }
    .card-precos { margin-top: auto; padding-top: 8px; }
    .preco-web { font-size: 12px; color: #94a3b8; text-decoration: line-through; }
    .preco-atual { font-size: 22px; font-weight: 900; color: var(--azul); }
    .card-acoes { display: flex; gap: 8px; margin-top: 12px; }
    .btn-card-wa { flex: 1; display: flex; align-items: center; justify-content: center; gap: 6px; background: #25d366; color: #fff; border: none; border-radius: 9px; padding: 10px 8px; font-size: 13px; font-weight: 700; text-decoration: none; cursor: pointer; transition: background .2s; font-family: inherit; }
    .btn-card-wa:hover { background: #1ebc59; }
    .btn-cart-card { width: 42px; height: 42px; border-radius: 9px; border: 2px solid #e2e8f0; background: #fff; cursor: pointer; font-size: 17px; display: flex; align-items: center; justify-content: center; transition: all .2s; flex-shrink: 0; }
    .btn-cart-card:hover { border-color: var(--laranja); }
    .btn-cart-card.ativo { border-color: var(--laranja); background: var(--laranja); color: #fff; }

    .vazio { grid-column: 1/-1; text-align: center; padding: 64px 24px; color: var(--texto-suave); }
    .vazio-icon { font-size: 48px; margin-bottom: 12px; }

    /* ── MODAL BASE ── */
    .modal-overlay { position: fixed; inset: 0; background: rgba(0,0,0,0.72); z-index: 500; display: none; align-items: flex-start; justify-content: center; overflow-y: auto; padding: 20px; }
    .modal-overlay.aberto { display: flex; }
    .modal-box { background: #fff; border-radius: 16px; max-width: 640px; width: 100%; margin: auto; overflow: hidden; position: relative; }

    /* ── MODAL PRODUTO ── */
    .produto-galeria { position: relative; background: #0d0d0d; width: 100%; aspect-ratio: 1; max-height: 380px; display: flex; align-items: center; justify-content: center; overflow: hidden; }
    .produto-galeria img { width: 100%; height: 100%; object-fit: contain; display: block; }
    .produto-galeria-vazio { font-size: 72px; color: #444; }
    .galeria-nav { position: absolute; top: 50%; transform: translateY(-50%); background: rgba(0,0,0,0.5); color: #fff; border: none; border-radius: 50%; width: 38px; height: 38px; font-size: 22px; cursor: pointer; display: flex; align-items: center; justify-content: center; transition: background .2s; }
    .galeria-nav:hover { background: rgba(0,0,0,0.75); }
    .galeria-nav.prev { left: 10px; }
    .galeria-nav.next { right: 10px; }
    .galeria-pontos { position: absolute; bottom: 10px; left: 50%; transform: translateX(-50%); display: flex; gap: 6px; }
    .galeria-ponto { width: 8px; height: 8px; border-radius: 50%; background: rgba(255,255,255,0.4); border: none; cursor: pointer; transition: background .2s; padding: 0; }
    .galeria-ponto.ativo { background: #fff; }
    .galeria-thumbs { display: flex; gap: 6px; padding: 10px 14px; background: #f8f9fa; overflow-x: auto; }
    .galeria-thumb { width: 56px; height: 56px; object-fit: cover; border-radius: 6px; cursor: pointer; border: 2px solid transparent; flex-shrink: 0; opacity: 0.65; transition: all .2s; }
    .galeria-thumb.ativo { border-color: var(--laranja); opacity: 1; }
    .galeria-thumb:hover { opacity: 1; }
    .produto-detalhes { padding: 20px 22px 24px; }
    .badge-modal { display: inline-block; background: #ef4444; color: #fff; border-radius: 6px; padding: 3px 10px; font-size: 12px; font-weight: 700; margin-bottom: 10px; }
    .produto-nome-modal { font-size: 20px; font-weight: 800; color: var(--azul); margin-bottom: 10px; line-height: 1.25; }
    .produto-descricao-modal { font-size: 14px; color: var(--texto-suave); line-height: 1.7; margin-bottom: 12px; }
    .produto-specs-modal { font-size: 13px; color: var(--texto-suave); margin-bottom: 12px; }
    .produto-precos-modal { margin-bottom: 18px; }
    .produto-preco-web-modal { font-size: 13px; color: #94a3b8; text-decoration: line-through; }
    .produto-preco-atual-modal { font-size: 30px; font-weight: 900; color: var(--azul); line-height: 1.1; }
    .produto-economia-modal { font-size: 13px; color: #22c55e; font-weight: 600; margin-top: 4px; }
    .modal-btns { display: flex; gap: 10px; flex-wrap: wrap; }
    .btn-interesse-modal { flex: 1; display: flex; align-items: center; justify-content: center; gap: 8px; background: #25d366; color: #fff; border: none; border-radius: 10px; padding: 13px 16px; font-size: 15px; font-weight: 700; cursor: pointer; text-decoration: none; font-family: inherit; transition: background .2s; }
    .btn-interesse-modal:hover { background: #1ebc59; }
    .btn-add-cart-modal { flex: 1; display: flex; align-items: center; justify-content: center; gap: 8px; background: var(--laranja); color: #fff; border: none; border-radius: 10px; padding: 13px 16px; font-size: 15px; font-weight: 700; cursor: pointer; font-family: inherit; transition: all .2s; }
    .btn-add-cart-modal.ativo { background: #e2e8f0; color: var(--texto-suave); }
    .btn-add-cart-modal:hover { opacity: 0.88; }
    .modal-fechar { position: absolute; top: 12px; right: 12px; background: rgba(0,0,0,0.5); color: #fff; border: none; border-radius: 50%; width: 34px; height: 34px; font-size: 16px; cursor: pointer; display: flex; align-items: center; justify-content: center; z-index: 10; transition: background .2s; }
    .modal-fechar:hover { background: rgba(0,0,0,0.75); }

    /* ── MODAL CARRINHO ── */
    .modal-box-cart { max-width: 480px; }
    .modal-cart-header { padding: 20px 22px 0; display: flex; align-items: center; justify-content: space-between; }
    .modal-cart-header h2 { font-size: 20px; font-weight: 800; color: var(--azul); }
    .modal-cart-fechar { background: #f0f0f0; border: none; border-radius: 50%; width: 32px; height: 32px; font-size: 16px; cursor: pointer; display: flex; align-items: center; justify-content: center; color: #555; transition: background .2s; }
    .modal-cart-fechar:hover { background: #e0e0e0; }
    .carrinho-vazio { padding: 48px 24px; text-align: center; color: var(--texto-suave); font-size: 15px; }
    .carrinho-vazio-icon { font-size: 48px; margin-bottom: 12px; }
    .carrinho-lista { max-height: 340px; overflow-y: auto; padding: 12px 22px; }
    .carrinho-item { display: flex; align-items: center; gap: 12px; padding: 10px 0; border-bottom: 1px solid #f1f5f9; }
    .carrinho-item:last-child { border-bottom: none; }
    .carrinho-item-foto { width: 58px; height: 58px; border-radius: 8px; object-fit: cover; flex-shrink: 0; background: #f1f5f9; display: flex; align-items: center; justify-content: center; font-size: 22px; }
    .carrinho-item-info { flex: 1; min-width: 0; }
    .carrinho-item-nome { font-size: 14px; font-weight: 600; color: var(--texto); white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
    .carrinho-item-preco { font-size: 15px; font-weight: 700; color: var(--azul); }
    .carrinho-item-remover { background: none; border: none; color: #ef4444; cursor: pointer; font-size: 18px; padding: 4px; flex-shrink: 0; transition: opacity .2s; }
    .carrinho-item-remover:hover { opacity: 0.7; }
    .carrinho-total { padding: 14px 22px; border-top: 2px solid #f1f5f9; display: flex; justify-content: space-between; align-items: center; }
    .carrinho-total-label { font-size: 14px; color: var(--texto-suave); font-weight: 600; }
    .carrinho-total-valor { font-size: 22px; font-weight: 900; color: var(--azul); }
    .carrinho-footer { padding: 14px 22px 22px; }
    .btn-enviar-carrinho { width: 100%; display: flex; align-items: center; justify-content: center; gap: 10px; background: #25d366; color: #fff; border: none; border-radius: 10px; padding: 15px; font-size: 16px; font-weight: 700; cursor: pointer; font-family: inherit; transition: background .2s; }
    .btn-enviar-carrinho:hover { background: #1ebc59; }

    /* ── CART FAB ── */
    .carrinho-fab { position: fixed; bottom: 24px; right: 24px; background: var(--laranja); color: #fff; border: none; border-radius: 50px; padding: 14px 20px; font-size: 16px; font-weight: 700; cursor: pointer; z-index: 400; display: none; align-items: center; gap: 8px; box-shadow: 0 4px 20px rgba(244,160,32,0.5); transition: all .2s; font-family: inherit; }
    .carrinho-fab:hover { transform: scale(1.05); box-shadow: 0 6px 28px rgba(244,160,32,0.6); }
    .carrinho-badge { background: #fff; color: var(--laranja); border-radius: 50%; width: 24px; height: 24px; display: flex; align-items: center; justify-content: center; font-size: 13px; font-weight: 900; }

    /* ── FOOTER ── */
    footer { background: var(--azul-escuro, #142d56); color: rgba(255,255,255,0.5); text-align: center; padding: 28px 24px; font-size: 13px; }
    footer a { color: var(--laranja); text-decoration: none; }
    footer a:hover { text-decoration: underline; }

    @media (max-width: 640px) {
      .hero { padding: 56px 16px 48px; }
      .diferenciais { gap: 14px; }
      .header-inner { padding: 0 16px; }
      .nav-btn { display: none; }
      .nav-mob-cat { display: block; }
      .nav-wa-text { display: none; }
      .nav-wa { padding: 9px 11px; border-radius: 50%; }
      .produto-galeria { max-height: 280px; }
      .carrinho-fab { bottom: 16px; right: 16px; padding: 12px 16px; font-size: 14px; }
      .btn-abrir-filtros { display: block; }
      .catalogo-layout { padding: 0 12px; margin-top: 16px; }
      .sidebar-backdrop.aberto { display: block; }
      .sidebar-filtros { position: fixed; top: 0; left: -100%; width: 280px; height: 100vh; max-height: 100vh; z-index: 300; border-radius: 0; transition: left .3s ease; }
      .sidebar-filtros.aberto { left: 0; }
      .sidebar-fechar { display: flex; }
      .grade { grid-template-columns: repeat(auto-fill, minmax(150px, 1fr)); gap: 12px; }
      .card-acoes { gap: 5px; }
      .btn-card-wa { font-size: 11px; padding: 10px 5px; }
      .btn-cart-card { width: 34px; height: 34px; font-size: 14px; }
    }
  </style>
</head>
<body>

<header>
  <div class="header-inner">
    <a class="logo-link" href="/" onclick="event.preventDefault(); mostrar('home')">${logoHeader}</a>
    <nav>
      <button class="nav-btn ativo" id="nav-home" onclick="mostrar('home')">Home</button>
      <button class="nav-btn" id="nav-catalogo" onclick="mostrar('catalogo')">Catálogo</button>
      <button class="nav-mob-cat" id="nav-mob-cat" onclick="mostrar('catalogo')">Ver Catálogo</button>
      <a class="nav-wa" href="https://wa.me/${CONTATO}">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413z"/><path d="M12 0C5.373 0 0 5.373 0 12c0 2.117.554 4.103 1.523 5.83L.057 23.428a.75.75 0 0 0 .916.916l5.638-1.474A11.953 11.953 0 0 0 12 24c6.627 0 12-5.373 12-12S18.627 0 12 0zm0 22a9.954 9.954 0 0 1-5.073-1.386l-.361-.214-3.742.979.998-3.648-.235-.376A9.956 9.956 0 0 1 2 12C2 6.478 6.478 2 12 2s10 4.478 10 10-4.478 10-10 10z"/></svg>
        <span class="nav-wa-text">WhatsApp</span>
      </a>
    </nav>
  </div>
</header>

<!-- ══ HOME ══ -->
<div class="page ativo" id="page-home">
  <section class="hero">
    ${logoHero}
    <h1>Logística reversa<br><span>com desconto real</span></h1>
    <p>Produtos de devoluções e sobras de estoque de grandes varejistas. Qualidade garantida com preços muito abaixo do mercado!</p>
    <div class="hero-btns">
      <button class="btn-hero-primary" onclick="mostrar('catalogo')">Ver Catálogo</button>
      <a class="btn-hero-ghost" href="https://wa.me/${CONTATO}">💬 Falar Comigo</a>
    </div>
  </section>

  <div class="diferenciais">
    <div class="dif-card"><div class="dif-icon">♻️</div><h3>Logística Reversa</h3><p>Trabalhamos com produtos de devoluções e sobras de grandes varejistas — itens de qualidade que você encontra com desconto real.</p></div>
    <div class="dif-card"><div class="dif-icon">💰</div><h3>Preços Abaixo do Mercado</h3><p>Você compara com qualquer grande loja e vai ver que compensa. Desconto garantido em todos os produtos!</p></div>
    <div class="dif-card"><div class="dif-icon">💬</div><h3>Atendimento no WhatsApp</h3><p>Rápido, direto e sem complicação. Chama no WhatsApp e a gente resolve!</p></div>
    <div class="dif-card"><div class="dif-icon">📍</div><h3>Mogi das Cruzes</h3><p>Daqui de Mogi pra você. Atendimento local com a confiança de quem é da região.</p></div>
  </div>

  <section class="sobre">
    <div class="sobre-inner">
      <h2>Quem é a <span>Mogi Outlet</span>?</h2>
      <p>Somos especializados em <strong>logística reversa</strong>: trabalhamos com produtos de devoluções e sobras de estoque de grandes varejistas, oferecendo itens de qualidade com preços muito abaixo do mercado.</p>
      <p>Cada produto do nosso catálogo foi verificado e selecionado com cuidado. Sem enrolação — é só chamar no WhatsApp e fechar negócio!</p>
      <span class="sobre-cidade">📍 Mogi das Cruzes — SP</span>
    </div>
  </section>

  <div class="cta">
    <h2>Gostou do que viu?</h2>
    <p>Veja todos os produtos no catálogo ou chama direto no WhatsApp. Estou pronto pra te atender!</p>
    <a class="btn-cta-wa" href="https://wa.me/${CONTATO}">
      <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413z"/><path d="M12 0C5.373 0 0 5.373 0 12c0 2.117.554 4.103 1.523 5.83L.057 23.428a.75.75 0 0 0 .916.916l5.638-1.474A11.953 11.953 0 0 0 12 24c6.627 0 12-5.373 12-12S18.627 0 12 0zm0 22a9.954 9.954 0 0 1-5.073-1.386l-.361-.214-3.742.979.998-3.648-.235-.376A9.956 9.956 0 0 1 2 12C2 6.478 6.478 2 12 2s10 4.478 10 10-4.478 10-10 10z"/></svg>
      Chamar no WhatsApp
    </a>
  </div>

  <footer><p>mogioutlet.com.br &mdash; Mogi das Cruzes &mdash; <a href="https://wa.me/${CONTATO}">WhatsApp</a></p></footer>
</div>

<!-- ══ CATÁLOGO ══ -->
<div class="page" id="page-catalogo">
  <div class="cat-header">
    <h2>Nosso Catálogo</h2>
    <p>Clique em um produto para ver detalhes ou adicione ao carrinho e envie tudo de uma vez!</p>
  </div>
  <div class="busca-wrap">
    <div class="busca-inner">
      <input type="text" id="busca" placeholder="🔍 Buscar produto..." oninput="filtrar()" />
      <button class="btn-abrir-filtros" onclick="abrirSidebar()">⚙️ Filtros</button>
    </div>
  </div>
  <div class="catalogo-layout">
    <div class="sidebar-backdrop" id="sidebar-backdrop" onclick="fecharSidebar()"></div>
    <aside class="sidebar-filtros" id="sidebar-filtros">
      <div class="sidebar-header">
        <span>Filtros</span>
        <button class="sidebar-fechar" onclick="fecharSidebar()">✕</button>
      </div>
      <div class="sidebar-body">
        <div class="sidebar-secao">
          <span class="sidebar-secao-label">Ordenar por</span>
          <select class="sort-select" id="sort-select" onchange="filtrar()">
            <option value="novo">✨ Mais recentes</option>
            <option value="asc">💰 Menor preço</option>
            <option value="desc">💎 Maior preço</option>
          </select>
        </div>
        <div class="sidebar-divider"></div>
        <div class="sidebar-secao">
          <span class="sidebar-secao-label">Categoria</span>
          <div id="cats-lista"></div>
        </div>
        <div class="sidebar-secao" id="subcats-secao" style="display:none">
          <div class="sidebar-divider" style="margin:0 0 10px"></div>
          <span class="sidebar-secao-label">Subcategoria</span>
          <div id="subcats-lista"></div>
        </div>
      </div>
    </aside>
    <div class="conteudo-catalogo">
      <div class="grade" id="grade"></div>
    </div>
  </div>
  <footer><p>mogioutlet.com.br &mdash; Mogi das Cruzes &mdash; <a href="https://wa.me/${CONTATO}">WhatsApp</a></p></footer>
</div>

<!-- ══ MODAL PRODUTO ══ -->
<div id="modal-produto" class="modal-overlay" onclick="fecharModalProduto()">
  <div class="modal-box" onclick="event.stopPropagation()">
    <button class="modal-fechar" onclick="fecharModalProduto()">✕</button>
    <div id="modal-produto-conteudo"></div>
  </div>
</div>

<!-- ══ MODAL CARRINHO ══ -->
<div id="modal-carrinho" class="modal-overlay" onclick="fecharCarrinhoModal()">
  <div class="modal-box modal-box-cart" onclick="event.stopPropagation()">
    <div class="modal-cart-header">
      <h2>🛒 Seu Carrinho</h2>
      <button class="modal-cart-fechar" onclick="fecharCarrinhoModal()">✕</button>
    </div>
    <div id="carrinho-lista" class="carrinho-lista"></div>
    <div class="carrinho-total">
      <span class="carrinho-total-label">Total</span>
      <span id="carrinho-total-valor" class="carrinho-total-valor">R$ 0,00</span>
    </div>
    <div class="carrinho-footer">
      <button class="btn-enviar-carrinho" onclick="enviarCarrinhoWA()">
        💬 Enviar lista no WhatsApp
      </button>
    </div>
  </div>
</div>

<!-- ══ CART FAB ══ -->
<button id="carrinho-fab" class="carrinho-fab" onclick="abrirCarrinhoModal()">
  🛒 <span class="carrinho-badge"><span id="carrinho-count">0</span></span>
</button>

<script>
  var CONTATO = '${CONTATO}';
  var produtos = ${produtosJSON};
  var carrinho = [];
  var modalProdutoAtual = null;
  var fotoModalIdx = 0;
  var catAtiva = '';
  var subcatAtiva = '';

  function fotos(p) {
    return (p.imagens && p.imagens.length) ? p.imagens : (p.imagem ? [p.imagem] : []);
  }

  function dim(p) {
    var partes = [];
    if (p.altura) partes.push(p.altura + 'cm');
    if (p.largura) partes.push(p.largura + 'cm');
    if (p.comprimento) partes.push(p.comprimento + 'cm');
    return partes.join(' x ');
  }

  function mostrar(pagina, empurrarUrl) {
    document.querySelectorAll('.page').forEach(function(el) { el.classList.remove('ativo'); });
    document.querySelectorAll('.nav-btn').forEach(function(el) { el.classList.remove('ativo'); });
    document.getElementById('page-' + pagina).classList.add('ativo');
    document.getElementById('nav-' + pagina).classList.add('ativo');
    var mobCat = document.getElementById('nav-mob-cat');
    if (mobCat) mobCat.style.display = pagina === 'catalogo' ? 'none' : '';
    window.scrollTo(0, 0);
    if (pagina === 'catalogo') { gerarCatsPills(); filtrar(); }
    // Atualiza a URL sem recarregar a página
    if (empurrarUrl !== false) {
      var caminho = pagina === 'catalogo' ? '/catalogo' : '/';
      history.pushState({ pagina: pagina }, '', caminho);
    }
  }

  function abrirSidebar() {
    document.getElementById('sidebar-filtros').classList.add('aberto');
    document.getElementById('sidebar-backdrop').classList.add('aberto');
    document.body.style.overflow = 'hidden';
  }

  function fecharSidebar() {
    document.getElementById('sidebar-filtros').classList.remove('aberto');
    document.getElementById('sidebar-backdrop').classList.remove('aberto');
    document.body.style.overflow = '';
  }

  function gerarCatsPills() {
    var catsUsadas = [];
    for (var i = 0; i < produtos.length; i++) {
      var cats = produtos[i].categorias || [];
      for (var j = 0; j < cats.length; j++) {
        if (catsUsadas.indexOf(cats[j]) < 0) catsUsadas.push(cats[j]);
      }
    }
    var html = '<button class="cat-item' + (!catAtiva ? ' ativo' : '') + '" data-cat="" onclick="filtrarCat(this)">Todos</button>';
    for (var k = 0; k < catsUsadas.length; k++) {
      html += '<button class="cat-item' + (catAtiva === catsUsadas[k] ? ' ativo' : '') + '" data-cat="' + catsUsadas[k] + '" onclick="filtrarCat(this)">' + catsUsadas[k] + '</button>';
    }
    document.getElementById('cats-lista').innerHTML = html;
  }

  function gerarSubcatsPills() {
    var subcatsUsadas = [];
    for (var i = 0; i < produtos.length; i++) {
      var p = produtos[i];
      var matchCat = !catAtiva || (p.categorias && p.categorias.indexOf(catAtiva) >= 0);
      if (matchCat) {
        var subcats = p.subcategorias || [];
        for (var j = 0; j < subcats.length; j++) {
          if (subcatsUsadas.indexOf(subcats[j]) < 0) subcatsUsadas.push(subcats[j]);
        }
      }
    }
    var secao = document.getElementById('subcats-secao');
    if (!subcatsUsadas.length) { secao.style.display = 'none'; return; }
    secao.style.display = '';
    var html = '<button class="cat-item subcat' + (!subcatAtiva ? ' ativo' : '') + '" data-subcat="" onclick="filtrarSubcat(this)">Todas</button>';
    for (var k = 0; k < subcatsUsadas.length; k++) {
      html += '<button class="cat-item subcat' + (subcatAtiva === subcatsUsadas[k] ? ' ativo' : '') + '" data-subcat="' + subcatsUsadas[k] + '" onclick="filtrarSubcat(this)">' + subcatsUsadas[k] + '</button>';
    }
    document.getElementById('subcats-lista').innerHTML = html;
  }

  function filtrarCat(btn) {
    catAtiva = btn.dataset.cat;
    subcatAtiva = '';
    document.querySelectorAll('#cats-lista .cat-item').forEach(function(el) { el.classList.remove('ativo'); });
    btn.classList.add('ativo');
    gerarSubcatsPills();
    filtrar();
  }

  function filtrarSubcat(btn) {
    subcatAtiva = btn.dataset.subcat;
    document.querySelectorAll('#subcats-lista .cat-item').forEach(function(el) { el.classList.remove('ativo'); });
    btn.classList.add('ativo');
    filtrar();
  }

  function filtrar() {
    var t = document.getElementById('busca').value.toLowerCase();
    var sort = document.getElementById('sort-select') ? document.getElementById('sort-select').value : 'novo';
    var lista = produtos.filter(function(p) {
      var matchText = !t || p.titulo.toLowerCase().indexOf(t) >= 0;
      var matchCat = !catAtiva || (p.categorias && p.categorias.indexOf(catAtiva) >= 0);
      var matchSubcat = !subcatAtiva || (p.subcategorias && p.subcategorias.indexOf(subcatAtiva) >= 0);
      return matchText && matchCat && matchSubcat;
    });
    lista.sort(function(a, b) {
      // Vendidos sempre por último
      if (!!a.vendido !== !!b.vendido) return a.vendido ? 1 : -1;
      if (sort === 'asc') return parseFloat(a.meuPreco) - parseFloat(b.meuPreco);
      if (sort === 'desc') return parseFloat(b.meuPreco) - parseFloat(a.meuPreco);
      return b.id - a.id;
    });
    renderizar(lista);
  }

  function renderizar(lista) {
    var el = document.getElementById('grade');
    if (!lista.length) {
      el.innerHTML = '<div class="vazio"><div class="vazio-icon">🔍</div><p>Nenhum produto encontrado</p></div>';
      return;
    }
    var html = '';
    for (var i = 0; i < lista.length; i++) {
      var p = lista[i];
      var imgs = fotos(p);
      var precoWeb = p.precoWeb && p.precoWeb !== '0' ? parseFloat(p.precoWeb) : null;
      var preco = parseFloat(p.meuPreco);
      var desc = precoWeb ? Math.round(((precoWeb - preco) / precoWeb) * 100) : 0;
      var medidas = dim(p);
      var link = 'https://wa.me/' + CONTATO + '?text=' + encodeURIComponent('Interesse: ' + p.titulo);
      var noCarrinho = carrinho.some(function(x) { return x.id === p.id; });

      html += '<div class="card' + (p.vendido ? ' card-vendido' : '') + '">';
      html += '<div class="card-foto" onclick="abrirProduto(' + p.id + ')">';
      if (imgs[0]) {
        html += '<img src="' + imgs[0] + '" alt="' + p.titulo.replace(/"/g, '&quot;') + '" loading="lazy">';
      } else {
        html += '📦';
      }
      if (imgs.length > 1) html += '<span class="foto-count">📷 ' + imgs.length + '</span>';
      if (p.vendido) html += '<span class="badge-vendido">VENDIDO</span>';
      else if (desc > 0) html += '<span class="badge-off">' + desc + '% OFF</span>';
      html += '</div>';
      html += '<div class="card-body">';
      html += '<div class="card-nome" onclick="abrirProduto(' + p.id + ')">' + p.titulo + '</div>';
      if (p.quantidade && !p.vendido) html += '<div class="card-estoque">📦 ' + p.quantidade + ' em estoque</div>';
      html += '<div class="card-precos">';
      if (precoWeb) html += '<div class="preco-web">R$ ' + precoWeb.toFixed(2) + '</div>';
      html += '<div class="preco-atual">R$ ' + preco.toFixed(2) + '</div>';
      html += '</div>';
      html += '<div class="card-acoes">';
      if (!p.vendido) html += '<a class="btn-card-wa" href="' + link + '">💬 Fazer Pedido</a>';
      else html += '<span style="flex:1;text-align:center;font-size:12px;color:#94a3b8;font-weight:600">Indisponível</span>';
      html += '<button class="btn-cart-card' + (noCarrinho ? ' ativo' : '') + '" id="btn-cart-' + p.id + '" onclick="toggleCarrinho(' + p.id + ')" title="' + (noCarrinho ? 'Remover do carrinho' : 'Adicionar ao carrinho') + '">' + (noCarrinho ? '✓' : '🛒') + '</button>';
      html += '</div>';
      html += '</div></div>';
    }
    el.innerHTML = html;
  }

  /* ── Produto modal ── */
  function abrirProduto(id) {
    modalProdutoAtual = null;
    for (var i = 0; i < produtos.length; i++) {
      if (produtos[i].id === id) { modalProdutoAtual = produtos[i]; break; }
    }
    if (!modalProdutoAtual) return;
    fotoModalIdx = 0;
    renderizarModalProduto();
    document.getElementById('modal-produto').classList.add('aberto');
    document.body.style.overflow = 'hidden';
  }

  function fecharModalProduto() {
    document.getElementById('modal-produto').classList.remove('aberto');
    document.body.style.overflow = '';
  }

  function renderizarModalProduto() {
    var p = modalProdutoAtual;
    var imgs = fotos(p);
    var precoWeb = p.precoWeb && p.precoWeb !== '0' ? parseFloat(p.precoWeb) : null;
    var preco = parseFloat(p.meuPreco);
    var descPct = precoWeb ? Math.round(((precoWeb - preco) / precoWeb) * 100) : 0;
    var medidas = dim(p);
    var link = 'https://wa.me/' + CONTATO + '?text=' + encodeURIComponent('Interesse: ' + p.titulo);
    var noCarrinho = carrinho.some(function(x) { return x.id === p.id; });

    var html = '';

    html += '<div class="produto-galeria">';
    if (imgs.length) {
      html += '<img id="galeria-img" src="' + imgs[fotoModalIdx] + '" alt="' + p.titulo.replace(/"/g, '&quot;') + '">';
      if (imgs.length > 1) {
        html += '<button class="galeria-nav prev" onclick="mudarFoto(-1)">&#8249;</button>';
        html += '<button class="galeria-nav next" onclick="mudarFoto(1)">&#8250;</button>';
        html += '<div class="galeria-pontos">';
        for (var j = 0; j < imgs.length; j++) {
          html += '<button class="galeria-ponto' + (j === fotoModalIdx ? ' ativo' : '') + '" onclick="irFoto(' + j + ')"></button>';
        }
        html += '</div>';
      }
    } else {
      html += '<div class="produto-galeria-vazio">📦</div>';
    }
    html += '</div>';

    if (imgs.length > 1) {
      html += '<div class="galeria-thumbs">';
      for (var k = 0; k < imgs.length; k++) {
        html += '<img src="' + imgs[k] + '" class="galeria-thumb' + (k === fotoModalIdx ? ' ativo' : '') + '" onclick="irFoto(' + k + ')" alt="Foto ' + (k + 1) + '">';
      }
      html += '</div>';
    }

    html += '<div class="produto-detalhes">';
    if (descPct > 0) html += '<span class="badge-modal">' + descPct + '% OFF</span>';
    html += '<h2 class="produto-nome-modal">' + p.titulo + '</h2>';
    if (p.descricao) html += '<p class="produto-descricao-modal">' + p.descricao + '</p>';
    html += '<div class="produto-precos-modal">';
    if (precoWeb) html += '<div class="produto-preco-web-modal">R$ ' + precoWeb.toFixed(2) + '</div>';
    html += '<div class="produto-preco-atual-modal">R$ ' + preco.toFixed(2) + '</div>';
    if (descPct > 0) html += '<div class="produto-economia-modal">Você economiza ' + descPct + '% em relação ao preço na internet</div>';
    html += '</div>';
    html += '<div class="modal-btns">';
    html += '<a class="btn-interesse-modal" href="' + link + '">💬 Fazer Pedido</a>';
    html += '<button class="btn-add-cart-modal' + (noCarrinho ? ' ativo' : '') + '" onclick="toggleCarrinho(' + p.id + ')">' + (noCarrinho ? '✓ No carrinho' : '🛒 Adicionar ao carrinho') + '</button>';
    html += '</div></div>';

    document.getElementById('modal-produto-conteudo').innerHTML = html;
  }

  function mudarFoto(dir) {
    var imgs = fotos(modalProdutoAtual);
    fotoModalIdx = (fotoModalIdx + dir + imgs.length) % imgs.length;
    document.getElementById('galeria-img').src = imgs[fotoModalIdx];
    document.querySelectorAll('.galeria-ponto').forEach(function(el, i) { el.classList.toggle('ativo', i === fotoModalIdx); });
    document.querySelectorAll('.galeria-thumb').forEach(function(el, i) { el.classList.toggle('ativo', i === fotoModalIdx); });
  }

  function irFoto(idx) {
    fotoModalIdx = idx;
    var imgs = fotos(modalProdutoAtual);
    document.getElementById('galeria-img').src = imgs[fotoModalIdx];
    document.querySelectorAll('.galeria-ponto').forEach(function(el, i) { el.classList.toggle('ativo', i === fotoModalIdx); });
    document.querySelectorAll('.galeria-thumb').forEach(function(el, i) { el.classList.toggle('ativo', i === fotoModalIdx); });
  }

  /* ── Carrinho ── */
  function toggleCarrinho(id) {
    var p = null;
    for (var i = 0; i < produtos.length; i++) { if (produtos[i].id === id) { p = produtos[i]; break; } }
    if (!p) return;
    var idx = -1;
    for (var j = 0; j < carrinho.length; j++) { if (carrinho[j].id === id) { idx = j; break; } }
    if (idx >= 0) { carrinho.splice(idx, 1); } else { carrinho.push(p); }
    var noCarrinho = carrinho.some(function(x) { return x.id === id; });
    atualizarFAB();
    var btnCard = document.getElementById('btn-cart-' + id);
    if (btnCard) {
      btnCard.textContent = noCarrinho ? '✓' : '🛒';
      btnCard.classList.toggle('ativo', noCarrinho);
      btnCard.title = noCarrinho ? 'Remover do carrinho' : 'Adicionar ao carrinho';
    }
    if (modalProdutoAtual && modalProdutoAtual.id === id) { renderizarModalProduto(); }
  }

  function atualizarFAB() {
    var n = carrinho.length;
    var fab = document.getElementById('carrinho-fab');
    fab.style.display = n > 0 ? 'flex' : 'none';
    document.getElementById('carrinho-count').textContent = n;
  }

  function abrirCarrinhoModal() {
    renderizarCarrinho();
    document.getElementById('modal-carrinho').classList.add('aberto');
    document.body.style.overflow = 'hidden';
  }

  function fecharCarrinhoModal() {
    document.getElementById('modal-carrinho').classList.remove('aberto');
    document.body.style.overflow = '';
  }

  function renderizarCarrinho() {
    var total = 0;
    for (var i = 0; i < carrinho.length; i++) { total += parseFloat(carrinho[i].meuPreco); }
    document.getElementById('carrinho-total-valor').textContent = 'R$ ' + total.toFixed(2);
    if (!carrinho.length) {
      document.getElementById('carrinho-lista').innerHTML = '<div class="carrinho-vazio"><div class="carrinho-vazio-icon">🛒</div><p>Seu carrinho está vazio</p></div>';
      return;
    }
    var html = '';
    for (var j = 0; j < carrinho.length; j++) {
      var p = carrinho[j];
      var imgs = fotos(p);
      var preco = parseFloat(p.meuPreco);
      html += '<div class="carrinho-item">';
      if (imgs[0]) {
        html += '<img class="carrinho-item-foto" src="' + imgs[0] + '" alt="' + p.titulo.replace(/"/g, '&quot;') + '">';
      } else {
        html += '<div class="carrinho-item-foto">📦</div>';
      }
      html += '<div class="carrinho-item-info"><div class="carrinho-item-nome">' + p.titulo + '</div><div class="carrinho-item-preco">R$ ' + preco.toFixed(2) + '</div></div>';
      html += '<button class="carrinho-item-remover" onclick="removerDoCarrinho(' + p.id + ')">✕</button>';
      html += '</div>';
    }
    document.getElementById('carrinho-lista').innerHTML = html;
  }

  function removerDoCarrinho(id) {
    var idx = -1;
    for (var i = 0; i < carrinho.length; i++) { if (carrinho[i].id === id) { idx = i; break; } }
    if (idx >= 0) carrinho.splice(idx, 1);
    atualizarFAB();
    renderizarCarrinho();
    var btnCard = document.getElementById('btn-cart-' + id);
    if (btnCard) { btnCard.textContent = '🛒'; btnCard.classList.remove('ativo'); btnCard.title = 'Adicionar ao carrinho'; }
  }

  function enviarCarrinhoWA() {
    if (!carrinho.length) return;
    var lista = '';
    for (var i = 0; i < carrinho.length; i++) {
      lista += (i + 1) + '. ' + carrinho[i].titulo + ' — R$ ' + parseFloat(carrinho[i].meuPreco).toFixed(2) + '\\n';
    }
    var total = 0;
    for (var j = 0; j < carrinho.length; j++) { total += parseFloat(carrinho[j].meuPreco); }
    var msg = 'Olá! Tenho interesse nos seguintes produtos:\\n\\n' + lista + '\\nTotal: R$ ' + total.toFixed(2);
    window.open('https://wa.me/' + CONTATO + '?text=' + encodeURIComponent(msg));
  }

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') { fecharModalProduto(); fecharCarrinhoModal(); fecharSidebar(); }
    if (document.getElementById('modal-produto').classList.contains('aberto')) {
      if (e.key === 'ArrowLeft') mudarFoto(-1);
      if (e.key === 'ArrowRight') mudarFoto(1);
    }
  });

  // Botão Voltar/Avançar do browser
  window.addEventListener('popstate', function(e) {
    var pagina = (e.state && e.state.pagina) ? e.state.pagina : 'home';
    mostrar(pagina, false);
  });

  // Abre a página certa de acordo com a URL ao entrar
  (function() {
    var pagina = window.location.pathname === '/catalogo' ? 'catalogo' : 'home';
    mostrar(pagina, false);
  })();
</script>
</body>
</html>`;
}

function ExportarSite({ products, isDirty, onPublicado }) {
  const [status, setStatus] = useState('idle'); // idle | publicando | publicado | erro | baixado

  const gerarHtmlAgora = () => {
    const logo = localStorage.getItem('logo');
    return gerarHTML(products, logo);
  };

  const publicar = async () => {
    if (products.length === 0) {
      alert('Cadastre pelo menos um produto antes de publicar.');
      return;
    }
    const workerUrl = localStorage.getItem('workerUrl');
    const authToken = localStorage.getItem('authToken');

    if (!workerUrl || !authToken) {
      alert('Configure a URL do Worker e o Token em ⚙️ Configurações primeiro.');
      return;
    }

    setStatus('publicando');
    try {
      const html = gerarHtmlAgora();
      const resp = await fetch(workerUrl.replace(/\/$/, '') + '/sync', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Auth-Token': authToken,
        },
        // Envia catálogo junto com o HTML para salvar no KV
        body: JSON.stringify({ html, produtos: products }),
      });
      if (!resp.ok) throw new Error('Resposta ' + resp.status);
      setStatus('publicado');
      if (onPublicado) onPublicado(); // marca como sem alterações pendentes
      setTimeout(() => setStatus('idle'), 4000);
    } catch (err) {
      console.error(err);
      setStatus('erro');
      setTimeout(() => setStatus('idle'), 4000);
    }
  };

  const baixar = () => {
    if (products.length === 0) {
      alert('Cadastre pelo menos um produto antes de exportar.');
      return;
    }
    const html = gerarHtmlAgora();
    const blob = new Blob([html], { type: 'text/html;charset=utf-8' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'index.html';
    a.click();
    URL.revokeObjectURL(url);
    setStatus('baixado');
    setTimeout(() => setStatus('idle'), 4000);
  };

  const temWorker = !!(localStorage.getItem('workerUrl') && localStorage.getItem('authToken'));

  // Label varia conforme status e se há alterações pendentes
  const labelPublicar = status !== 'idle'
    ? { publicando: '⏳ Salvando...', publicado: '✅ Salvo e publicado!', erro: '❌ Erro — tente novamente', baixado: '✅ HTML baixado!' }[status]
    : isDirty
      ? '💾 Salvar & Publicar'
      : '🌐 Publicar Site';

  const classePublicar = [
    'btn-exportar',
    (status === 'publicado' || status === 'baixado') ? 'exportado' : '',
    (isDirty && status === 'idle') ? 'sujo' : '',
  ].filter(Boolean).join(' ');

  return (
    <div style={{ display: 'flex', gap: '8px' }}>
      <button
        className={classePublicar}
        onClick={publicar}
        disabled={status === 'publicando'}
        title={
          !temWorker
            ? 'Configure o Worker em ⚙️ Configurações'
            : isDirty
              ? 'Salvar catálogo e publicar site no Cloudflare'
              : 'Republicar site no Cloudflare'
        }
      >
        {labelPublicar}
      </button>
      <button
        className="btn-exportar-html"
        onClick={baixar}
        title="Baixar index.html (backup local)"
        style={{ display: temWorker ? 'block' : 'none' }}
      >
        💾 HTML
      </button>
    </div>
  );
}

export default ExportarSite;
